// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1Fepe","sectionsWrapper":"style_sectionsWrapper__1MAk3"};